var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log_out_icon",
    "data-name": "log out icon",
    transform: "translate(-316 -50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 24,
    height: 24,
    transform: "translate(316 50)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(316 50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M20.9,11.6c-.1-.1-.1-.2-.2-.3l-3-3a.99.99,0,1,0-1.4,1.4L17.6,11H13a1,1,0,0,0,0,2h4.6l-1.3,1.3a.967.967,0,0,0,0,1.4.967.967,0,0,0,1.4,0l3-3c.1-.1.2-.2.2-.3a1.1,1.1,0,0,0,0-.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M15.5,18.1A7.3,7.3,0,0,1,12,19,7,7,0,0,1,12,5a7.3,7.3,0,0,1,3.5.9,1.03,1.03,0,0,0,1-1.8A9.969,9.969,0,0,0,12,3a9,9,0,1,0,4.5,16.8,1.107,1.107,0,0,0,.4-1.4A1.076,1.076,0,0,0,15.5,18.1Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1ea35d747ccbd14a3c292d6c4a3edd6c.svg";
export { ForwardRef as ReactComponent };